import * as React from "react";
import {Button} from "@mui/material";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

export default function ButtonComponent(props) {

    const BootstrapButton = styled(Button)({
        height: '2.5em',
        fontSize: 'inherit',
        font: 'inherit',
        backgroundColor: '#28ADE0',
        textTransform: 'none',
        fontWeight: 'bold',
        borderRadius: '5px',

        '&:hover': {
            backgroundColor: '#3B687A',
        }

    });

    return <BootstrapButton {...props} variant="contained">
        {props.children}
    </BootstrapButton>
}

ButtonComponent.propTypes = {
    onClick: PropTypes.func,
}